// Colour tokens for surfaces that take colour STRINGS rather than classes:
// the Cytoscape canvas and the Timeline SVG. Each token is a CSS custom
// property in index.css, defined for light and dark, so reading it here at
// render time gives the theme's value and leaves no hex literal in a
// component (style gate, 88.5.4).

/** `rgb(r g b)` for a tres-* token such as `--tres-action`. */
export function tokenRgb(name: string, alpha?: number): string {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  if (!raw) return alpha === undefined ? 'rgb(128 128 128)' : `rgb(128 128 128 / ${alpha})`;
  return alpha === undefined ? `rgb(${raw})` : `rgb(${raw} / ${alpha})`;
}

/** `rgb(r, g, b)` with commas: the form the graph canvas parses. It reads
 *  colours itself, and the space-separated `rgb(r g b)` and `hsl(h s% l%)`
 *  forms fell back to black there, which painted every edge label box black
 *  behind grey text after the style sweep (88.8). */
export function tokenRgbComma(name: string): string {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length !== 3) return 'rgb(128, 128, 128)';
  return `rgb(${parts.join(', ')})`;
}

/** `hsl(h s l)` for a shadcn base token such as `--card` or `--foreground`. */
export function tokenHsl(name: string): string {
  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return raw ? `hsl(${raw})` : 'hsl(0 0% 50%)';
}
